import { useState, useEffect, useRef } from "react";

type CallbackFunction = () => void;

const useAutoPolling = (
  callback: CallbackFunction,
  interval: number = 5000
) => {
  const [isPolling, setIsPolling] = useState<boolean>(true);
  const savedCallback = useRef<CallbackFunction>();

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    let intervalId: NodeJS.Timeout;

    const tick = () => {
      if (savedCallback.current) {
        savedCallback.current();
      }
    };

    if (isPolling) {
      intervalId = setInterval(tick, interval);
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [isPolling, interval]);

  const startPolling = () => setIsPolling(true);
  const stopPolling = () => setIsPolling(false);

  return { isPolling, startPolling, stopPolling };
};

export default useAutoPolling;
